<template>
  <div>
    <Table />
  </div>
</template>

<script>
import Table from './Table.vue'
export default {
  name: 'superAdminList',
  components: { Table },
  props: {},
}
</script>

<style></style>
